export class ProductTableModel {
  code: string;
  description: string;
  price: number;
  tax: number;
  taxCode: string;
  stock: number;
  total: number;
  requiredSerial: boolean;
  delivereable: string;
  features: { [value: string]: string };
  hasWarranty: boolean;
  comboSetProducts: Array<ProductTableModel>;
  quantity: number;
  setCorrelative: string;
  serviceType: string;
  isService: boolean;
  extraWarrantyInvoiceCode: string;
  extraWarrantyInvoiceLine: string;
  associatedOrder: string;
  associatedOrderEntry: string;
  serialNumber: string;
  select: boolean;
  orderEntryCode: string;
  productWithExtraWarranty: string;
  comboProduct: string;
  invoiceable: boolean;
  wharehouseLocation: string;
  wharehouseNumber: string;
  constructor() {
    this.code = "";
    this.description = "";
    this.price = 0.0;
    this.stock = 0;
    this.tax = 0.0;
    this.total = 0.0;
    this.taxCode = "";
    this.requiredSerial = false;
    this.delivereable = "";
    this.features = {};
    this.hasWarranty = false;
    this.comboSetProducts = [];
    this.quantity = 0;
    this.setCorrelative = '';
    this.comboProduct = "";
    this.serviceType = '';
    this.isService = false;
    this.extraWarrantyInvoiceCode = '';
    this.extraWarrantyInvoiceLine = '';
    this.associatedOrder = '';
    this.associatedOrderEntry = '';
    this.select = false;
    this.orderEntryCode = '';
    this.serialNumber = '';
    this.productWithExtraWarranty = 'false';
    this.invoiceable = false;
    this.wharehouseLocation = "";
    this.wharehouseNumber = "";
  }

  setCode(code: string) {
    this.code = code;
    return this;
  }

  setDescription(description: string) {
    this.description = description;
    return this;
  }

  setPrice(price: number) {
    this.price = price;
    return this;
  }

  setTax(tax: number) {
    this.tax = tax;
    return this;
  }
  setStock(stock: number) {
    this.stock = stock;
    return this;
  }

  setTotal(total: number) {
    this.total = total;
    return this;
  }

  setTaxCode(taxCode: string) {
    this.taxCode = taxCode;
    return this;
  }

  setDelivereable(delivereable: string) {
    this.delivereable = delivereable;
    return this;
  }

  setRequiredSerial(requiredSerial: boolean) {
    this.requiredSerial = requiredSerial;
    return this;
  }

  setFeatures(features: { [value: string]: string }) {
    this.features = features;
    return this;
  }

  setHasWarranty(hasWarranty: boolean) {
    this.hasWarranty = hasWarranty;
    return this;
  }

  setComboSetProducts(comboSetProduts: Array<ProductTableModel>) {
    this.comboSetProducts = comboSetProduts;
    return this;
  }

  setQuantity(quantity: number) {
    this.quantity = quantity;
    return this;
  }

  setSetCorrelative(setCorrelative: string) {
    this.setCorrelative = setCorrelative;
    return this;
  }

  setServiceType(serviceType: string) {
    this.serviceType = serviceType;
    return this;
  }

  setIsService(isService: boolean) {
    this.isService = isService;
    return this;
  }

  setExtraWarrantyInvoiceCode(extraWarrantyInvoiceCode: string) {
    this.extraWarrantyInvoiceCode = extraWarrantyInvoiceCode;
    return this;
  }

  setExtraWarrantyInvoiceLine(extraWarrantyInvoiceLine: string) {
    this.extraWarrantyInvoiceLine = extraWarrantyInvoiceLine;
    return this;
  }

  setAssociatedOrderEntry(associatedOrderEntry: string) {
    this.associatedOrderEntry = associatedOrderEntry;
    return this;
  }

  setAssociatedOrder(associatedOrder: string) {
    this.associatedOrder = associatedOrder;
    return this;
  }

  setSelect(select: boolean) {
    this.select = select;
    return this;
  }

  setOrderEntryCode(orderEntryCode: string) {
    this.orderEntryCode = orderEntryCode;
    return this;
  }

  setSerialNumber(serialNumber: string) {
    this.serialNumber = serialNumber;
    return this;
  }

  setProductWithExtraWarranty(productWithExtraWarranty: string) {
    this.productWithExtraWarranty = productWithExtraWarranty;
    return this;
  }

  setComboProduct(comboProduct: string) {
    this.comboProduct = comboProduct;
    return this;
  }

  setInvoiceable(invoiceable: boolean) {
    this.invoiceable = invoiceable;
    return this;
  }

  setWharehouseLocation(wharehouseLocation: string) {
    this.wharehouseLocation = wharehouseLocation;
    return this;
  }
  setWharehouseNumber(wharehouseNumber: string) {
    this.wharehouseNumber = wharehouseNumber;
    return this;
  }
}
